import { Flex } from '@chakra-ui/react';
import React from 'react';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';
import { UI } from 'src/apps/invest/common/shells/UI';

export const CompleteYourProfile: React.FC = () => {
  return (
    <UI containerPadding={0}>
      <Flex flex={1} justifyContent="center">
        <Flex
          maxWidth={['100%']}
          w={'100%'}
          backgroundSize={['cover', 'cover', 'cover', 'cover', '100%']}
          backgroundRepeat={'no-repeat'}
          flex={1}
          backgroundPosition={['center', 'center', 'bottom']}
          backgroundImage={[
            '/assets/gfx/blurred-properties-mobile.png',
            '/assets/gfx/blurred-properties-mobile.png',
            '/assets/gfx/blurred-properties.png',
          ]}>
          <Flex
            flexDirection={'column'}
            w={'100%'}
            maxW={'500px'}
            m={' 0 auto'}
            padding={['20px', '0']}
            alignItems="center">
            <TextBlock mt={'56px'} textAlign="center" weight="bold" fontSize="36px">
              Please complete your profile
            </TextBlock>
            <TextBlock mt={'9px'} maxW={'350px'} textAlign="center">
              Once you finish setting up your account you will be able to invest in our HomeShares properties.
            </TextBlock>
          </Flex>
        </Flex>
      </Flex>
    </UI>
  );
};
